import { useSelector } from "react-redux";

const Mentions = () => {
  /**
   * Mentions est une page qui affiche les mentions légales du site.
   * Elle contient des informations sur la propriété du site, les conditions d'utilisation, le contenu du site et la gestion du site.
   * Chaque section est présentée sous la forme d'un article avec un titre et un paragraphe de texte.
   * Les informations sont présentées dans un format facile à lire pour l'utilisateur.
   *
   */

  const appNumber = useSelector((state) => state.app.appNumber);

  const siteUrl =
    appNumber === 4
      ? "https://mesbonsplansghr.hapluspme.com"
      : appNumber === 5
      ? "https://mesbonsplansagpm.hapluspme.com"
      : appNumber === 6
      ? "https://mesbonsplansmedef.hapluspme.com"
      : "https://mesbonsplans.klesia.fr";

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="card-theme mb-8">
          <h1 className="text-4xl font-bold text-theme-primary mb-6">
            Mentions légales
          </h1>
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed">
              Le site{" "}
              <a
                href={siteUrl}
                className="text-theme-accent hover:text-theme-accent-active transition-colors"
              >
                {siteUrl}
              </a>{" "}
              est la propriété de la société LANA, SAS au capital de 1 000 €,
              ayant son siège social au 6 bis Avenue de l'Europe 78117 Toussus
              Le Noble, RCS Versailles 883 168 999 L'internaute reconnaît que
              l'utilisation du site{" "}
              <a
                href={siteUrl}
                className="text-theme-accent hover:text-theme-accent-active transition-colors"
              >
                {siteUrl}
              </a>{" "}
              en tant que tel ainsi que toutes les activités qui peuvent être
              développées sur le site, sont régies par le droit français. LANA
              tient à attirer l'attention des utilisateurs de son site sur les
              points suivants:
            </p>
          </div>
        </div>
        <div className="card-theme mb-6">
          <h2 className="text-2xl font-bold text-theme-primary mb-4">
            Article 1 – Site internet
          </h2>

          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-semibold text-theme-primary mb-2">
                Edité par :
              </h3>
              <p className="text-gray-700 leading-relaxed">
                HA PLUS PME SAS au capital de 115 295.00 €, Ayant son siège
                social au 6 Avenue de l'Europe 78117 Toussus Le Noble,
                Représentée par Anthony STREICHER, en qualité de directeur
                général Immatriculée au RCS de Versailles B 519 215 966
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-theme-primary mb-2">
                Développement du site par :
              </h3>
              <p className="text-gray-700 leading-relaxed">
                HA PLUS PME, 6 Avenue de l'Europe 78117 Toussus Le Noble,
                <br />
                RCS Versailles B 519 215 966
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-theme-primary mb-2">
                Hébergé par :
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Ce site est hébergé chez Azure Microsoft,
                <br />
                France Central DB
              </p>
            </div>
          </div>
        </div>
        <div className="card-theme mb-6">
          <h2 className="text-2xl font-bold text-theme-primary mb-4">
            Article 2- Accès au site
          </h2>
          <p className="text-gray-700 leading-relaxed">
            L'accès au site et son utilisation sont réservés à un usage
            strictement personnel. Vous vous engagez à ne pas utiliser ce site
            et les informations ou données qui y figurent à des fins
            commerciales, politiques, publicitaires et pour toute forme de
            sollicitation commerciale et notamment l'envoi de courriers
            électroniques non sollicités.
          </p>
        </div>

        <div className="card-theme mb-6">
          <h2 className="text-2xl font-bold text-theme-primary mb-4">
            Article 3 – Contenu du site
          </h2>
          <p className="text-gray-700 leading-relaxed">
            Toutes les marques, logos, fichiers disponibles en téléchargement,
            base de données figurant sur le site, charte graphique, structure
            générale du site photographies, textes, commentaires, illustrations,
            images animées ou non, séquences vidéo, sons, ainsi que toutes les
            applications informatiques qui pourraient être utilisées pour faire
            fonctionner ce site et plus généralement tous les éléments
            reproduits ou utilisés sur le site sont protégés par les lois en
            vigueur au titre de la propriété intellectuelle. Ils sont la
            propriété pleine et entière de l'éditeur ou de ses partenaires.
            Toute reproduction, représentation, utilisation ou adaptation, sous
            quelque forme que ce soit, de tout ou partie de ces éléments, y
            compris les applications informatiques, sans l'accord préalable et
            écrit de l'éditeur, sont strictement interdites. Toute utilisation
            des éléments du présent site à des fins différentes que celles
            visées ci-dessus fera l'objet de poursuites judiciaires, en France,
            comme à l'étranger. Les bases de données sont protégées au titre du
            droit applicable aux compilations de données. Toute extraction ou
            tentative d'extraction, totale ou partielle, est susceptible
            d'engager la responsabilité civile et pénale du contrevenant.
          </p>
        </div>

        <div className="card-theme mb-6">
          <h2 className="text-2xl font-bold text-theme-primary mb-4">
            Article 4- Gestion du site
          </h2>
          <p className="text-gray-700 leading-relaxed">
            Pour la bonne gestion du site, l'éditeur pourra à tout moment : –
            suspendre, interrompre ou limiter l'accès à tout ou partie du site,
            réserver l'accès au site, ou à certaines parties du site, à une
            catégorie déterminée d'internautes ; – supprimer toute information
            pouvant en perturber le fonctionnement ou entrant en contravention
            avec les lois nationales ou internationales ; – suspendre le site
            afin de procéder à des mises à jour.
          </p>
        </div>

        <div className="card-theme mb-6">
          <h2 className="text-2xl font-bold text-theme-primary mb-4">
            Article 5- Responsabilité technique
          </h2>
          <p className="text-gray-700 leading-relaxed">
            La responsabilité de l'éditeur ne peut être engagée en cas de
            défaillance, panne, difficulté ou interruption de fonctionnement,
            empêchant l'accès au site ou à une de ses fonctionnalités ou du fait
            de l'utilisateur. Le matériel de connexion au site que vous utilisez
            est sous votre entière responsabilité. Vous devez prendre toutes les
            mesures appropriées pour protéger votre matériel et vos propres
            données notamment d'attaques virales par Internet. Vous êtes par
            ailleurs seul responsable des sites et données que vous consultez.
            L'éditeur n'est pas responsable des dommages causés à vous-même, à
            des tiers et/ou à votre équipement du fait de votre connexion ou de
            votre utilisation du site et vous renoncez à toute action contre lui
            de ce fait. Si l'éditeur venait à faire l'objet d'une procédure
            amiable ou judiciaire en raison de votre utilisation du site, il
            pourrait se retourner contre vous pour obtenir l'indemnisation de
            tous les préjudices, sommes, condamnations et frais qui pourraient
            découler de cette procédure.
          </p>
        </div>

        <div className="card-theme mb-6">
          <h2 className="text-2xl font-bold text-theme-primary mb-4">
            Article 6- Cookies
          </h2>
          <p className="text-gray-700 leading-relaxed">
            Le site{" "}
            <a
              href={siteUrl}
              className="text-theme-accent hover:text-theme-accent-active transition-colors"
            >
              {siteUrl}
            </a>{" "}
            utilise des cookies. Ces fichiers de données stockés sur
            l'ordinateur de l'Utilisateur ont pour but de faciliter la
            navigation sur le présent site. En configurant son navigateur,
            l'Utilisateur a la possibilité de s'opposer à l'enregistrement. Pour
            plus d'informations sur l'utilisation, la gestion et la suppression
            des « cookies », pour tout type de navigateur, nous vous invitons à
            consulter le lien suivant :{" "}
            <a
              href="https://cnil.fr/fr/cookies-les-outils-pour-les-maitriser"
              className="text-theme-accent hover:text-theme-accent-active transition-colors"
            >
              https://cnil.fr/fr/cookies-les-outils-pour-les-maitriser
            </a>
            .
          </p>
        </div>

        <div className="card-theme mb-6">
          <h2 className="text-2xl font-bold text-theme-primary mb-4">
            Article 7- Liens hypertextes
          </h2>
          <p className="text-gray-700 leading-relaxed">
            La mise en place par les utilisateurs de tous liens hypertextes vers
            tout ou partie du site est strictement interdite, sauf autorisation
            préalable et écrite de l'éditeur. L'éditeur est libre de refuser
            cette autorisation sans avoir à justifier de quelque manière que ce
            soit sa décision. Dans le cas où l'éditeur accorderait son
            autorisation, celle-ci n'est dans tous les cas que temporaire et
            pourra être retirée à tout moment, sans obligation de justification
            à la charge de l'éditeur. Toute information accessible via un lien
            vers d'autres sites n'est pas publiée par l'éditeur. L'éditeur ne
            dispose d'aucun droit sur le contenu présent dans ledit lien.
          </p>
        </div>

        <div className="card-theme mb-6">
          <h2 className="text-2xl font-bold text-theme-primary mb-4">
            Article 8- Contactez nous
          </h2>
          <p className="text-gray-700 leading-relaxed">
            Pour toute question, information sur la protection des données
            personnelles, vous pouvez nous écrire à l'adresse suivante :{" "}
            <a
              href="mailto:rgpd@ca-cpourmoi.com"
              className="text-theme-accent hover:text-theme-accent-active transition-colors"
            >
              rgpd@ca-cpourmoi.com
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default Mentions;
